"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash"));

var _flattenColorPalette = _interopRequireDefault(require("../util/flattenColorPalette"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default() {
  return function (_ref) {
    var addUtilities = _ref.addUtilities,
        e = _ref.e,
        theme = _ref.theme,
        variants = _ref.variants;
    var colors = (0, _flattenColorPalette.default)(theme('divideColor'));

    var utilities = _lodash.default.fromPairs(_lodash.default.map(_lodash.default.omit(colors, 'default'), function (value, modifier) {
      return [".".concat(e("divide-".concat(modifier)), " > :not(template) ~ :not(template)"), {
        'border-color': value
      }];
    }));

    addUtilities(utilities, variants('divideColor'));
  };
}